import PasswordSetup from "./password-setup";

export default PasswordSetup;